import React, { useState } from "react"
import { Link } from "gatsby"
import Style from "./nav.module.scss"

// TODO 8: Items should be rendered in a forEach()
/**
 * ArticleNav (Default): The navigation menu
 * for articles that displays on the editorial
 * landing page. Consists of three images.
 */
const ArticleNav = props => {
  const issueSlug = props.slug
  return (
    <div>
      <nav className={Style.editorialNav}>
        <div className={Style.navLinkContainer}>
          <Link to={`/${issueSlug}/${props.articles[0].slug}`}>
            <NavItem
              color={props.articles[0].color}
              title={props.articles[0].title}
              author={props.articles[0].author}
              image={"http:" + props.articles[0].navImage.file.url}
            />
          </Link>
        </div>
        <div className={Style.navLinkContainer}>
          <Link to={`/${issueSlug}/${props.articles[1].slug}`}>
            <NavItem
              color={props.articles[1].color}
              title={props.articles[1].title}
              author={props.articles[1].author}
              image={"http:" + props.articles[1].navImage.file.url}
            />
          </Link>
        </div>
        <div className={Style.navLinkContainer}>
          <Link to={`/${issueSlug}/${props.articles[2].slug}`}>
            <NavItem
              color={props.articles[2].color}
              title={props.articles[2].title}
              author={props.articles[2].author}
              image={"http:" + props.articles[2].navImage.file.url}
            />
          </Link>
        </div>
      </nav>

      <IssueTitle issueTitle={props.issueTitle} />
    </div>
  )
}

export default ArticleNav

/* ===================================================*/

const NavItem = props => {
  const [hoverStyling, setHoverStyling] = useState({
    backgroundColor: "#FFFFFF",
    color: "#000000",
  })

  return (
    <div
      className={Style.navLink}
      style={{ backgroundColor: props.color }}
      // Supresses dumb warning
      role="button"
      tabIndex={0}
      // Highlights span text on mouse hover
      onMouseEnter={() => {
        setHoverStyling({ backgroundColor: props.color, color: "#FFFFFF" })
      }}
      onMouseLeave={() => {
        setHoverStyling({ backgroundColor: "#FFFFFF", color: "#000000" })
      }}
    >
      <div className={Style.editorialLinkText}>
        <span
          style={{
            backgroundColor: hoverStyling.backgroundColor,
            color: hoverStyling.color,
            padding: "1%",
          }}
        >
          {props.title.toUpperCase()}
        </span>
        <br />
        <br />
        <span
          className={Style.editorialAuthorText}
          style={{
            backgroundColor: hoverStyling.backgroundColor,
            color: hoverStyling.color,
            padding: "1%",
            marginLeft: "25%",
          }}
        >
          by {props.author}
        </span>
        <br />
      </div>
      <div className={Style.articleLinkImageContainer}>
        <img
          className={Style.articleLinkImage}
          src={props.image}
          alt={props.title}
        />
      </div>
    </div>
  )
}

/**
 * IssueTitle: Main title for the archive issue. Appears
 * at the bottom of the nav links
 */
const IssueTitle = props => {
  const archiveNumber = props.issueTitle.split("—")[0]
  const archiveTitle = props.issueTitle.split("—")[1]
  return (
    <div className={Style.issueTitle}>
      <span style={{ backgroundColor: "#FFFFFF" }}>
        {archiveNumber.toUpperCase() + " — "}
        <br />
        {archiveTitle.toUpperCase()}
      </span>
    </div>
  )
}
